import {QueryClient} from '@tanstack/react-query';
import {isAxiosError} from 'axios';
import {HTTP_STATUS} from '@/constants';

// Configure a default, robust QueryClient instance
export const queryClient = new QueryClient({
    defaultOptions: {
        queries: {
            refetchOnWindowFocus: false, // Disables automatic refetching when browser window is focused
            retry: (failureCount, error) => {
                // 如果是 403 权限鉴权报错，则不再重试(重试也注定失败), 避免Toast重复提示
                if (isAxiosError(error)) {
                    if (error.response?.status === HTTP_STATUS.FORBIDDEN) {
                        return false;
                    }
                }
                return failureCount < 1; // 其它错误只允许重试 1 次
            },
            // 携带 meta.pageInit=true 的页面初始化 Query 遇到 403 时抛出 React Error，
            // 由 LazyWrapper 中的 ErrorBoundary(level="page") 统一渲染无权限视图
            throwOnError: (error, query) => {
                if (isAxiosError(error)) {
                    return (
                        error.response?.status === HTTP_STATUS.FORBIDDEN &&
                        query.meta?.pageInit === true
                    );
                }
                return false;
            },
            staleTime: 1000 * 60 * 5, // Data is considered fresh for 5 minutes
        },
    },
});
